import type { WalletTopUpsTranslations } from "../interfaces/walletTopUps";

export const walletTopUpsTranslations: WalletTopUpsTranslations = {
  page_title: "Wallet top-ups",
  page_subtitle:
    "Credit Coloca funds to a client's wallet. Each top-up asks for your verification code, is recorded and sends the client the receipt.",
  action_refresh: "Refresh the history",
  action_new: "New top-up",
  action_retry: "Retry",
  filter_organization: "Organization",
  filter_all_option: "All organizations",
  filter_all_hint: "Showing the top-ups of every organization.",
  filter_org_hint: "Showing only this organization's top-ups.",

  empty_title: "No top-ups yet",
  empty_description: "The top-ups you make show up here with their receipt.",
  col_date: "Date",
  col_organization: "Organization",
  col_amount: "Amount",
  col_concept: "Concept and internal note",
  col_reference: "Reference",
  col_by: "Made by",
  col_receipt: "Receipt",
  card_note: "Internal note: {{note}}",
  card_by: "Made by {{email}}",

  dialog_title: "Top up a wallet",
  dialog_title_review: "Review the top-up",
  dialog_title_done: "Top-up credited",
  dialog_title_processing: "Crediting the top-up…",
  dialog_description: "The balance comes from Coloca's funds and is available to the client at once.",
  dialog_description_review: "Check the organization, the wallet and the amount before you authorize it.",
  dialog_description_done: "The client already sees the top-up in their statement.",
  dialog_description_processing:
    "We are crediting the balance and emailing the receipt; it can take a few seconds. Do not close this window.",
  processing_from: "Coloca Payments",
  processing_transit_aria:
    "{{amount}} {{currency}} on their way from Coloca Payments to {{name}}'s {{currency}} wallet.",
  action_cancel: "Cancel",
  action_review: "Review top-up",
  action_back: "Back",
  action_confirm: "Authorize top-up",
  action_another: "Make another top-up",
  action_close: "Close",

  field_organization: "Organization",
  field_organization_required_hint: "Choose the organization that receives the top-up.",
  field_organization_hint: "The top-up is credited to a wallet of this organization.",
  organization_unknown: "the organization",
  field_wallet: "Wallet",
  field_wallet_hint: "The wallet's currency is the top-up currency.",
  field_wallet_placeholder: "Choose a wallet",
  field_wallet_none: "This organization has no activated wallets. Activate one from Wallets and try again.",
  field_wallet_option: "{{currency}} · balance {{balance}}",
  field_wallet_option_inactive: "{{currency}} · {{status}}",
  wallet_frozen: "frozen",
  wallet_closed: "closed",
  field_amount: "Amount",
  field_amount_hint: "In {{currency}}. Added to the available balance.",
  field_concept: "Concept",
  field_concept_hint: "The client sees it in their statement, the email and the receipt.",
  concept_default: "Balance top-up",
  field_note: "Internal note",
  field_note_hint: "Only Coloca's team sees it: why it is credited and where the funds are.",
  field_note_placeholder: "E.g. funds already received at the provider, support request #482",

  validation_wallet: "Choose the wallet that receives the top-up.",
  validation_amount: "Enter an amount greater than zero.",
  validation_amount_precision: "{{currency}} allows at most {{digits}} decimals.",
  validation_concept: "Enter the concept the client will see.",
  validation_note: "Enter an internal note for the record.",

  review_organization: "Organization",
  review_wallet: "Wallet",
  review_wallet_value: "{{currency}} wallet",
  review_balance_before: "Available balance now",
  review_amount: "Top-up from Coloca Payments",
  review_balance_after: "Balance after the top-up",
  review_concept: "Concept (the client sees it)",
  review_note: "Internal note",
  review_client_sees:
    "The client will see it as a top-up from Coloca Payments and get the receipt by email. You get a copy too.",
  review_irreversible: "The top-up is immediate and cannot be undone from the panel.",
  review_checkbox: "I checked the organization, the wallet and the amount",

  two_factor_required:
    "Topping up wallets needs two-step verification turned on. Turn it on in Settings and come back.",
  two_factor_description: "You are about to credit {{amount}} {{currency}} to {{name}}.",

  unresolved_title: "A top-up was left unconfirmed",
  unresolved_text:
    "A top-up of {{amount}} (“{{concept}}”) to this organization was authorized and its answer never arrived, so we don't know whether it was credited. Check it before making another one.",
  unresolved_text_retry:
    "The answer never arrived, so we don't know whether this top-up was credited. Check it, or authorize it again: if it had already gone through, it is not credited twice.",
  unresolved_action: "Check the top-up",
  unresolved_pending: "It is still being processed. Check again in a few seconds.",
  unresolved_unknown: "We couldn't check it. Try again in a moment.",
  unresolved_not_placed: "The unconfirmed top-up was not credited. You can make the top-up now.",
  top_up_busy:
    "Another tab is sending a top-up to this organization. Wait for it to finish and authorize again; nothing was sent.",
  unresolved_blocked:
    "A top-up to this organization is still unconfirmed. Check it before making another one.",

  done_recovered:
    "The unconfirmed top-up was credited. This is its receipt; checking it credited nothing again.",
  done_replayed:
    "This top-up had already been made with the same details. Nothing was credited again and no email was sent.",
  done_receipt_label: "Top-up receipt",
  done_credited: "Credited",
  done_amount: "Amount credited",
  done_beneficiary: "Beneficiary",
  done_wallet: "Wallet",
  done_concept: "Concept",
  done_origin: "Origin",
  done_emails_label: "Emails sent",
  email_pending: "We are emailing the receipt {{who}}.",
  email_sent: "We sent the receipt {{who}}.",
  email_failed: "We could not send the email {{who}}. Download the receipt and share it.",
  email_no_address: "No email went {{who}}: there is no email on record.",
  email_to_operator: "to your email",
  email_to_accounting: "to the accounting address",
  email_to_organization: "to the organization",

  receipt_download: "Download receipt",
  receipt_download_for: "Download receipt {{reference}}",
  receipt_share: "Share",
  receipt_share_title: "Top-up receipt {{reference}}",
  receipt_error: "We could not get the receipt: {{message}}",
  kind_incident_refund: "Refund",
  done_receipt_label_refund: "Refund receipt",
};
